import gql from 'graphql-tag';

// Mesma fonte que o app mobile usa para montar as abas: quem decide quais
// tabs a conta tem, em que ordem, com que rotulo e icone, e a API.
export const QUERY_STUDENT_ACCOUNT = gql`
  query studentAccount {
    account {
      id
      name
      code
      avatar {
        uri
      }
      app {
        id
        settings {
          fontFamily
          colors {
            background
            body
            border
            neutral
            neutralLighten
            primary
            primaryText
            secondary
            tertiary
            text
          }
          navigationTabs {
            show
            icon
            label
            screen
          }
          screens {
            wodListDate {
              programFilter
            }
            wodList {
              programFilter
              navEnabled
            }
            wods {
              programFilter
            }
            courses {
              columnList
              navEnabled
            }
            records {
              navEnabled
            }
            favorites {
              navEnabled
            }
            completions {
              navEnabled
            }
            timer {
              navEnabled
            }
            schedule {
              navEnabled
            }
            anthropometric {
              navEnabled
            }
          }
        }
      }
    }
  }
`;

// O feed exige JWT: `social` nao esta na allowlist do
// GraphqlPublicOperationPolicy, diferente de `account`.
export const QUERY_STUDENT_SOCIAL = gql`
  query studentSocial($first: Int, $after: String) {
    social(first: $first, after: $after, type: community) {
      endCursor
      hasNextPage
      list {
        id
        message
        createdAt
        likesTotal
        liked
        pinned
        author {
          id
          name
          avatar {
            uri
          }
        }
        image {
          uri
        }
        comments {
          total
        }
      }
    }
  }
`;

// A conta pode restringir os treinos a certos programas
// (settings.screens.wodListDate.programFilter), como o app mobile faz.
export const QUERY_STUDENT_WODS = gql`
  query studentWods($date: String, $programIds: [ID!]) {
    wods(date: $date, programIds: $programIds) {
      id
      name
      date
      description
      completedOnDate
      isFavorited
      cover {
        uri
      }
      video {
        uri
      }
      comments {
        total
      }
    }
  }
`;

// Detalhe do treino: o card da lista nao traz os blocos nem os exercicios,
// entao a tela de visualizacao busca o wod inteiro por id.
export const QUERY_STUDENT_WOD = gql`
  query studentWod($id: ID!) {
    wod(id: $id) {
      id
      name
      date
      description
      completedOnDate
      cover {
        uri
      }
      video {
        uri
      }
      workouts {
        id
        title
        description
        timeText
        exerciseWorkouts {
          id
          repetitions
          load
          rounds
          timeText
          restTime
          notes
          exercise {
            id
            name
          }
        }
      }
    }
  }
`;

// aulasPorDia exige tz — sem ele o backend recusa a query.
export const QUERY_STUDENT_SCHEDULE = gql`
  query studentSchedule($date: String!, $tz: String!) {
    aulasPorDia(date: $date, tz: $tz) {
      programClasses {
        id
        startTime
        endTime
        limit
        countCheckins
        canCheckin
        checkin {
          id
        }
        program {
          name
        }
        filial {
          name
        }
        coach {
          name
        }
      }
    }
  }
`;

export const QUERY_STUDENT_COURSES = gql`
  query studentCourses($page: Int) {
    courses(page: $page) {
      id
      title
      resume
      courseStatus
      poster {
        uri
      }
      cover {
        uri
      }
      nextUnit {
        id
        title
      }
    }
  }
`;

// Detalhe do curso: a lista nao traz modulos nem aulas.
export const QUERY_STUDENT_COURSE = gql`
  query studentCourse($id: ID!) {
    course(id: $id) {
      id
      title
      description
      resume
      courseStatus
      poster {
        uri
      }
      cover {
        uri
      }
      trailer {
        uri
      }
      courseModules {
        id
        title
        description
        order
        units {
          id
          title
          resume
          unitType
          completed
        }
      }
      units {
        id
        title
        resume
        unitType
        completed
      }
    }
  }
`;

// Detalhe da aula, com a midia que o aluno precisa para assistir.
export const QUERY_STUDENT_UNIT = gql`
  query studentUnit($id: ID!) {
    unit(id: $id) {
      id
      title
      description
      resume
      unitType
      completed
      cover {
        uri
      }
      video {
        uri
      }
      audio {
        uri
      }
      course {
        id
        title
      }
    }
  }
`;

// Detalhe do post: o card do feed traz so o total de comentarios.
export const QUERY_STUDENT_POST = gql`
  query studentPost($id: ID!) {
    post(id: $id) {
      id
      message
      createdAt
      likesTotal
      liked
      pinned
      author {
        id
        name
        avatar {
          uri
        }
      }
      image {
        uri
      }
      comments {
        total
        list {
          id
          message
          author {
            id
            name
            avatar {
              uri
            }
          }
        }
      }
    }
  }
`;

export const QUERY_STUDENT_ME = gql`
  query studentMe {
    me {
      id
      fullName
      shortName
      email
      avatar {
        uri
      }
    }
  }
`;

export const QUERY_STUDENT_RECORDS = gql`
  query studentRecords($page: Int, $search: String) {
    records(page: $page, search: $search) {
      id
      name
      category
      unit
      image {
        uri
      }
      lastResult {
        id
        result
        resultNumber
        date
      }
    }
  }
`;

export const QUERY_STUDENT_FAVORITES = gql`
  query studentFavorites($page: Int) {
    favorites(page: $page) {
      total
      page
      list {
        id
        targetType
        target {
          id
          name
          cover {
            uri
          }
        }
      }
    }
  }
`;

export const QUERY_STUDENT_COMPLETIONS = gql`
  query studentCompletions($page: Int) {
    userCompletions(page: $page) {
      total
      page
      list {
        id
        targetType
        completionDate
        target {
          id
          name
          cover {
            uri
          }
        }
      }
    }
  }
`;

export const QUERY_STUDENT_ANTHROPOMETRICS = gql`
  query studentAnthropometrics {
    anthropometrics {
      id
      date
      weight
      leanMass
      muscleMass
      absoluteFat
    }
  }
`;

export const QUERY_STUDENT_CHALLENGES = gql`
  query studentChallenges($page: Int) {
    challenges(page: $page) {
      id
      title
      description
      status
      challengeType
      targetValue
      targetUnit
      result
      challenger {
        name
      }
    }
  }
`;

// Checkins e DeleteCheckin sao RelayClassicMutation, entao recebem input.
export const MUTATION_STUDENT_CHECKIN = gql`
  mutation studentCheckin($programClassId: ID!) {
    checkins(input: {programClassId: $programClassId}) {
      checkin {
        id
      }
    }
  }
`;

export const MUTATION_STUDENT_DELETE_CHECKIN = gql`
  mutation studentDeleteCheckin($checkinId: ID!) {
    deleteCheckin(input: {checkinId: $checkinId}) {
      checkin {
        id
      }
    }
  }
`;

// Pedir id/liked/likesTotal de volta faz o Apollo normalizar o post no cache e
// atualizar o card sozinho, sem recarregar o feed inteiro.
export const MUTATION_STUDENT_LIKE = gql`
  mutation studentLike($postId: ID!, $action: String!) {
    actLike(input: {postId: $postId, action: $action}) {
      post {
        id
        liked
        likesTotal
      }
    }
  }
`;

export const MUTATION_STUDENT_FAVORITE = gql`
  mutation studentFavorite($targetId: ID!, $targetType: TargetTypeEnum!, $targetAction: TargetActionEnum!) {
    createOrRemoveFavorite(input: {targetId: $targetId, targetType: $targetType, targetAction: $targetAction}) {
      result
    }
  }
`;

export const MUTATION_STUDENT_COMPLETION = gql`
  mutation studentCompletion($targetId: ID!, $targetType: TargetTypeEnum!, $completionDate: String!) {
    setUserCompletion(input: {targetId: $targetId, targetType: $targetType, completionDate: $completionDate}) {
      result
    }
  }
`;
